import { VehicleStatus } from './vehicleStatus';

export const VehicleStatusCategory = {
  ON_GROUND: 'on_ground',
  PREFLIGHT: 'preflight',
  INFLIGHT_NOMINAL: 'inflight_nominal',
  INFLIGHT_FAILURE_MODE: 'inflight_failure_mode',
  POSTFLIGHT: 'postflight'
} as const;

export type VehicleStatusCategory = (typeof VehicleStatusCategory)[keyof typeof VehicleStatusCategory];

export function getVehicleStatusCategory(status: VehicleStatus): VehicleStatusCategory {
  switch (status) {
    // Inflight failure mode statuses
    case VehicleStatus.SAFING_UP:
    case VehicleStatus.SAFED_UP:
    case VehicleStatus.DESCENDING:
    case VehicleStatus.DESCENDED:
    case VehicleStatus.ABORT_HOME:
    case VehicleStatus.FC_RTL:
    case VehicleStatus.EMERGENCY_LANDING:
    case VehicleStatus.EXECUTING_FALLBACK_MISSION:
    case VehicleStatus.FC_LOSS:
    case VehicleStatus.PARACHUTE_TRIGGERED:
    case VehicleStatus.VEHICLE_DISCONNECTED:
      return VehicleStatusCategory.INFLIGHT_FAILURE_MODE;

    // Preflight statuses
    case VehicleStatus.PREFLIGHT:
    case VehicleStatus.READY_FOR_TAKEOFF:
      return VehicleStatusCategory.PREFLIGHT;

    // Inflight nominal statuses
    case VehicleStatus.TAKING_OFF:
    case VehicleStatus.INFLIGHT_TO_PICKUP:
    case VehicleStatus.PICKING_UP:
    case VehicleStatus.WAITING_FOR_PACKAGE_LOADED_CONFIRMATION:
    case VehicleStatus.INFLIGHT_TO_DESTINATION:
    case VehicleStatus.INFLIGHT_HOME:
    case VehicleStatus.LANDING_HOME:
    case VehicleStatus.WAITING_FOR_WIRE_DROP_CONFIRMATION:
    case VehicleStatus.PERFORMING_WIRE_DROP:
    case VehicleStatus.HOVERING_PAUSED:
    case VehicleStatus.RC_IN_CONTROL:
      return VehicleStatusCategory.INFLIGHT_NOMINAL;

    // Postflight statuses
    case VehicleStatus.MISSION_COMPUTER_POSTFLIGHT:
    case VehicleStatus.PENDING_POSTFLIGHT:
      return VehicleStatusCategory.POSTFLIGHT;

    // On ground statuses
    case VehicleStatus.PENDING_MISSION:
    case VehicleStatus.PENDING_PREPARATION:
      return VehicleStatusCategory.ON_GROUND;

    default:
      return VehicleStatusCategory.ON_GROUND;
  }
}
